import store from '@/store'

const config = {}

for (const variable in store.state.config) {
  Object.defineProperty(config, variable, {
    get() {
      return store.getters.config[variable]
    },
    set(value) {
      const newValues = {}
      newValues[variable] = value
      store.dispatch('updateConfig', newValues)
    },
  })
}

config.reset = (prop) => {
  if (prop) {
    config[prop] = undefined
    return false
  }
  store.dispatch('update', {userConfig: {}})
}

export default config
